import {useEffect,useState} from 'react';
import {applyTheme,readTheme,type Theme} from '../theme';
import {Icon} from './Icon';

const themes=[
  {value:'light',label:'Светлая тема',icon:'sun'},
  {value:'dark',label:'Тёмная тема',icon:'moon'},
  {value:'pink',label:'Розовая тема',icon:'flower'},
] as const;

export function ThemePicker() {
  const [theme,setTheme]=useState(readTheme);
  useEffect(()=>applyTheme(theme),[theme]);
  function select(next:Theme){if(next===theme)return;applyTheme(next,true);setTheme(next);}
  return <div className="theme-picker" role="group" aria-label="Тема оформления" data-theme={theme}>
    <span className="theme-picker-indicator" aria-hidden="true"/>
    {themes.map(item=><button key={item.value} className="theme-picker-button" type="button" title={item.label} aria-label={item.label} aria-pressed={theme===item.value} onClick={()=>select(item.value)}><Icon name={item.icon} size={18}/></button>)}
  </div>;
}
